import { render, staticRenderFns } from "./CardAdvanceAppDesign.vue?vue&type=template&id=24ffbf94"
import script from "./CardAdvanceAppDesign.vue?vue&type=script&lang=js"
export * from "./CardAdvanceAppDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports